<template>
    <div>
        <div class="content mb-2">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <md-card>
                        <md-card-header data-background-color="orange">
                            <div class="btn-toolbar justify-content-between mb-0">
                                <div>
                                    <h4 class="title">{{ $t('registers.events.evaluation.tempRanking.pendingConfirmation') }}</h4>
                                </div>
                                <div>
                                    <h4>
                                        <button v-if="expanded" class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                            <i class="fas fa-compress-arrows-alt text-white"></i>
                                        </button>
                                        <button v-else class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                            <i class="fas fa-expand-arrows-alt text-white"></i>
                                        </button>
                                    </h4>
                                </div>
                            </div>

                            <p class="category">{{ $t('registers.events.evaluation.tempRanking.pendingConfirmationDetails') }}</p>
                        </md-card-header>

                        <md-card-content>
                            <div class="mb-2">
                                <div class="input-group col-sm-5 float-right">
                                    <div class="input-group-addon fa fa-search"></div>
                                    <input class="form-control" name="query" v-on:keyup.esc.stop="clearFilters" v-model="upcomingEventsSearchKey" />
                                    <button class="btn btn-secondary"
                                            @click.stop="clearFilters">
                                        <i class="fas fa-times"></i>
                                        {{ $t('buttons.clear.btnText') }}
                                    </button>
                                </div>
                            </div>

                            <div class="loader" v-if="loading"></div>
                            <div v-else>
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col" class="w-50">{{$t('upcomingEvents.gridHeaders.name')}}</th>
                                            <th scope="col">{{$t('upcomingEvents.gridHeaders.startTime')}}</th>
                                            <th scope="col">{{$t('upcomingEvents.gridHeaders.endTime')}}</th>
                                            <th scope="col">{{$t('upcomingEvents.gridHeaders.statuses')}}</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in filteredData" :key="'myUpcomingEvents'+index" :id="'myUpcomingEvent'+ item.id">
                                            <th scope="row">{{index+1}}</th>
                                            <td>
                                                {{item.name}}
                                                <i class="fas fa-eye pointer text-primary float-right" @click="eventDetailsBtnClick(item)"
                                                   :title="$t('buttons.eventDetails.btnText')"></i>
                                            </td>
                                            <td>{{item.startTimeUtc ? $moment(item.startTimeUtc).format('DD.MM.YYYY HH:mm') : ''}}</td>
                                            <td>{{item.endTimeUtc ? $moment(item.endTimeUtc).format('DD.MM.YYYY HH:mm') : ''}}</td>
                                            <td>{{item.statuses}}</td>
                                            <td>
                                                <span v-if="item.canConfirmEventSubscriptionRequest">
                                                    <button class="btn btn-link text-success" @click.stop="confirmEventSubscriptionRequest(item, $event)" :title="$t('upcomingEvents.participationRequestConfirmation')" data-toggle="tooltip">
                                                        <i class="fas fa-check"></i>
                                                        {{ $t('buttons.confirm.btnText') }}
                                                    </button>
                                                </span>

                                                <span v-if="item.canEditEventSubscriptionRequest">
                                                    <button class="btn btn-link text-success" @click.stop="editEventSubscriptionRequest(item, $event)" :title="$t('upcomingEvents.participationRequestConfirmation')" data-toggle="tooltip">
                                                        <i class="fas fa-edit"></i>
                                                        {{ $t('buttons.edit.btnText') }}
                                                    </button>
                                                </span>

                                                <span v-if="item.canRejectEventSubscriptionRequest">
                                                    <button class="btn btn-link text-danger" @click.stop="rejectEventSubscriptionRequest(item, $event)" :title="$t('upcomingEvents.participationRequestRejection')" data-toggle="tooltip">
                                                        <i class="fas fa-times"></i>
                                                        {{ $t('buttons.reject.btnText') }}
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>

        </div>

        <DetailsModal v-model="detailsModel" :show="showEventDetails" @onClose="onEventDetailsClose"></DetailsModal>
        <ConfirmationEditModal v-model="confirmationModel" :show="showConfirmation" @onCreate="onConfirmationCreate" @onClose="onConfirmationClose"></ConfirmationEditModal>
    </div>
</template>

<script>
    import { RegisterFieldValueQueryFilter } from '@/models/enums';
    import { UpcomingEvent, TempRankingToPersonModel } from '@/models/models';
    import tempRankingService from '@/services/tempRanking.service';
    import participantService from '@/services/participant.service';
    import bus from '@/components/sidemenu/event-bus';
    import ConfirmationEditModal from "@/components/dynamic/events/accommodationRequest/edit.modal";
    import DetailsModal from '@/components/dynamic/register/details.modal';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            ConfirmationEditModal,
            DetailsModal
        },
        props: {
            userId: {
                type: String,
                default: null
            },
            pendingConfirmationExpanded: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                expanded: this.pendingConfirmationExpanded,
                upcomingEvents: [],
                upcomingEventsSearchKey: '',
                showConfirmation: false,
                confirmationModel: null,
                detailsModel: null,
                showEventDetails: false,
            };
        },
        methods: {
            clearSource() {
                if (Array.isArray(this.upcomingEvents)) {
                    while (this.upcomingEvents.length > 0) {
                        this.upcomingEvents.pop();
                    }
                }
            },
            loadTempRankingToConfirm() {
                this.clearSource();
                this.loading = true;

                tempRankingService.loadTempRankingToConfirm(this.userId || '')
                    .then(response => {
                        if (response.data) {
                            response.data.forEach(obj => {
                                this.upcomingEvents.push(new UpcomingEvent(obj))
                            })
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .then(() => (this.loading = false));
            },
            confirmEventSubscriptionRequest(item, event) {
                this.confirmationModel = new TempRankingToPersonModel({
                    id: item.tempRankingId,
                    registerEntityId: item.id,
                    eventName: item.name,
                    eventStartDate: item.startTimeUtc,
                    eventEndDate: item.endTimeUtc,
                    accommodationFromTimeUtc: item.accommodationFromTimeUtc,
                    accommodationToTimeUtc: item.accommodationToTimeUtc,
                    tempRankingAccommodationRequestRequired: item.accommodationRequestRequired
                });

                this.showConfirmation = true;
            },
            editEventSubscriptionRequest(item, event) {
                participantService.getParticipationDetailsById(item.participationDetailsId)
                    .then(response => {
                        this.confirmationModel = new TempRankingToPersonModel(response.data);
                        this.showConfirmation = true
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            rejectEventSubscriptionRequest(item, event) {
                kendo.prompt(`${this.$t('registers.events.evaluation.tempRanking.confirmRejection')}`, '')
                    .then(function (data) {
                        let model = new TempRankingToPersonModel({
                            id: item.tempRankingId,
                            registerEntityId: item.id,
                            eventName: item.name,
                            eventStartDate: item.startTimeUtc,
                            eventEndDate: item.endTimeUtc,
                            note: data
                        });

                        tempRankingService.rejectTampRanking(model)
                            .then(response => {
                                this.$emit("rejected", model)
                                this.reload();

                                this.$vs.notify({
                                    title: this.$t(
                                        'request.response.status.' +
                                        this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(
                                        response
                                    ),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration
                                });
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t(
                                        'request.response.status.' +
                                        this.$helpers.errorStatusCode(error)
                                    ),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters
                                        .notificationDuration
                                });
                            });
                    }.bind(this));
            },
            reload() {
                this.loadTempRankingToConfirm();
            },
            sizeToggle() {
                this.expanded = !this.expanded;
                this.$emit('sizeToggle')
            },
            onConfirmationCreate(model) {
                this.$emit("confirmed", model)
                this.reload();
            },
            onConfirmationClose() {
                this.showConfirmation = false;
                this.confirmationModel = null;
            },
            clearFilters() {
                this.upcomingEventsSearchKey = '';
            },
            onEventAdded(id, eventName, eventCode) {
                this.reload();
            },
            onEventUpdated(id, eventName, eventCode) {
                this.reload();
            },
            onEventDeleted(id, eventName, eventCode) {
                this.reload();
            },
            eventDetailsBtnClick: function (item) {
                this.showDetailsModal(item.id, RegisterFieldValueQueryFilter.All);
            },
            showDetailsModal(registerEntityId, filter) {
                this.$api.dynamicRegister
                    .getDetails(registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showEventDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showEventDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onEventDetailsClose() {
                this.showEventDetails = false;
                this.detailsModel = null;
            }
        },
        mounted() {
            this.loadTempRankingToConfirm();

            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['isEnVersion']),
            isNew() {
                return isNaN(this.id) || this.id === undefined || this.id === 0;
            },
            filteredData() {
                var filterKey = this.upcomingEventsSearchKey && this.upcomingEventsSearchKey.toLowerCase();
                var data = this.upcomingEvents;
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                        });
                    });
                }

                return data;
            }
        },
        created() {
            this.bus = bus;

            this.bus.$on('event-addded', this.onEventAdded);
            this.bus.$on('event-updated', this.onEventUpdated);
            this.bus.$on('event-deleted', this.onEventDeleted);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('event-addded', this.onEventAdded);
            this.bus.$off('event-updated', this.onEventUpdated);
            this.bus.$off('event-deleted', this.onEventDeleted);
        },
    };
</script>

<style scoped>
</style>
